// Campus photo for /colleges/kansas-state-university: CC BY-SA 4.0, by ShameraKane, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AAndersonHallKSU1_7-9-15.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/kansas-state-university/; credited under the photo.
const photo = {
    "slug": "kansas-state-university",
    "alt": "Anderson Hall at Kansas State University in Manhattan, Kansas",
    "src": "/colleges/kansas-state-university/campus-1600.webp",
    "srcSmall": "/colleges/kansas-state-university/campus-800.webp",
    "srcMid": "/colleges/kansas-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/kansas-state-university/og.jpg",
    "title": "AndersonHallKSU1 7-9-15",
    "author": "ShameraKane",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AAndersonHallKSU1_7-9-15.jpg",
    "read": "2026-10-01"
};

export default photo;
